import { SplashPage } from "@/components/splash-page";
import { useToken } from "@/hooks/authentication";
import { Redirect } from "react-router-dom";

const HomeRedirect = () => {
  const [token, { isLoading }] = useToken()

  if (isLoading) {
    return <SplashPage />
  }

  if (token) {
    return <Redirect to="/songs" />
  } else {
    return <Redirect to="/sign-in" />
  }
}

export default HomeRedirect;
